/* ============================================================
   sollie-v2-dropdowns.js — behaviour for snippets/sollie-v2-dropdowns.liquid
   (CB2-classic PDP dropdowns, 2026-09-15).
   - "Read more" in DETAILS reveals the second paragraph.
   - "Measuring tips" opens the guide in a native <dialog>; Escape, the ×
     button or a click on the backdrop closes it.
   Delegated on document, so a Horizon variant morph that replaces the
   product section keeps working. Idempotent if loaded twice.
   ============================================================ */
(function () {
  'use strict';
  if (window.__sv2DropdownsInit) return;
  window.__sv2DropdownsInit = true;

  var lastTrigger = null;

  function openTips(trigger) {
    var dlg = document.getElementById(trigger.getAttribute('data-sv2-tips') || 'sv2-tips');
    if (!dlg || typeof dlg.showModal !== 'function' || dlg.open) return;
    lastTrigger = trigger;
    dlg.showModal();
    var x = dlg.querySelector('[data-sv2-tips-close]');
    if (x) x.focus();
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || typeof t.closest !== 'function') return;

    var more = t.closest('.sv2-dd__more');
    if (more) {
      var rest = document.getElementById(more.getAttribute('aria-controls') || '');
      if (!rest) return;
      rest.hidden = !rest.hidden;
      more.setAttribute('aria-expanded', rest.hidden ? 'false' : 'true');
      more.textContent = rest.hidden ? 'Read more' : 'Read less';
      return;
    }

    var tips = t.closest('[data-sv2-tips]');
    if (tips) { openTips(tips); return; }

    var close = t.closest('[data-sv2-tips-close]');
    if (close) {
      var d = close.closest('dialog');
      if (d && d.open) d.close();
      return;
    }

    /* a click on the backdrop lands on the <dialog> element itself */
    if (t.tagName === 'DIALOG' && t.classList.contains('sv2-tips') && t.open) {
      var r = t.getBoundingClientRect();
      var inside = e.clientX >= r.left && e.clientX <= r.right && e.clientY >= r.top && e.clientY <= r.bottom;
      if (!inside) t.close();
    }
  });

  /* Horizon's variant change does not re-render this stack, so mark the size
     group that matches the picked option values client-side. */
  function markSelectedSize(form) {
    var stack = document.querySelector('[data-sv2-dd]');
    if (!stack) return;
    var groups = stack.querySelectorAll('[data-sv2-opt]');
    if (!groups.length) return;
    var picked = [];
    Array.prototype.forEach.call(form.querySelectorAll('input:checked, select'), function (el) {
      if (el.value) picked.push(el.value);
    });
    Array.prototype.forEach.call(groups, function (g) {
      g.classList.toggle('is-current', picked.indexOf(g.getAttribute('data-sv2-opt')) !== -1);
    });
  }

  document.addEventListener('change', function (e) {
    var form = e.target && e.target.closest && e.target.closest('variant-picker form, form.variant-picker__form');
    if (form) markSelectedSize(form);
  });

  document.addEventListener('close', function (e) {
    if (e.target && e.target.classList && e.target.classList.contains('sv2-tips') && lastTrigger && document.contains(lastTrigger)) {
      lastTrigger.focus();
    }
  }, true);
})();
